import { render, staticRenderFns } from "./OrdersSituation.vue?vue&type=template&id=73830264"
import script from "./OrdersSituation.vue?vue&type=script&lang=js"
export * from "./OrdersSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports